import React, { useState } from 'react';
import api from '../../services/api';
import { useMessage } from '../../components/Message';

const DeleteConfirmModal = ({ deleteConfirm, deleteType, setDeleteType, onClose, onRefresh }) => {
    const [deleting, setDeleting] = useState(false);
    const { showMessage } = useMessage();

    const handleDelete = async () => {
        setDeleting(true);
        try {
            const response = await api.delete(`/admin/games/${deleteConfirm}?permanent=${deleteType === 'permanent'}`);
            showMessage(`Game ${deleteType === 'permanent' ? 'permanently deleted' : 'deactivated'}`, 'success');
            onRefresh();
            onClose();
        } catch (error) {
            if (error.code === 'ERR_NETWORK') {
                showMessage('Network error - cannot connect to server. Is the backend running?', 'error');
            } else {
                showMessage(error.response?.data?.message || error.message || 'Delete failed', 'error');
            }
        } finally {
            setDeleting(false);
        }
    };

    return (
        <div className="admin-delete-modal-overlay">
            <div className="admin-delete-modal">
                <h3 className="admin-delete-modal-title">Confirm Delete</h3>
                <p className="admin-delete-modal-text">Are you sure you want to delete this game?</p>
                
                <div className="admin-delete-options">
                    <label className="admin-delete-option">
                        <input
                            type="radio"
                            value="soft"
                            checked={deleteType === 'soft'}
                            onChange={() => setDeleteType('soft')}
                            className="admin-delete-radio"
                        />
                        Soft Delete (hide from users)
                    </label>
                    <label className="admin-delete-option">
                        <input
                            type="radio"
                            value="permanent"
                            checked={deleteType === 'permanent'}
                            onChange={() => setDeleteType('permanent')}
                            className="admin-delete-radio"
                        />
                        Permanent Delete (remove files)
                    </label>
                </div>

                <div className="admin-delete-modal-actions">
                    <button onClick={handleDelete} className="admin-btn-delete-confirm" disabled={deleting}>
                        {deleting ? 'Deleting...' : `Yes, ${deleteType === 'permanent' ? 'Permanently Delete' : 'Deactivate'}`}
                    </button>
                    <button onClick={onClose} className="admin-btn-cancel">Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;